exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width: 375px) {\n    .card__CardOutgoingInvoice-module___32BjH {\n      min-width: 260px;\n    }\n    .list__CardOutgoingInvoice-module___2ZL8b {\n        font-size: 12px;\n    }\n  \n  }", ""]);

// Exports
exports.locals = {
	"card": "card__CardOutgoingInvoice-module___32BjH",
	"list": "list__CardOutgoingInvoice-module___2ZL8b"
};